import { Daily10LeaderboardScreen } from '@/screens/daily10/Daily10LeaderboardScreen'

export default function Daily10LeaderboardRoute() {
  return <Daily10LeaderboardScreen />
}
